export const NINJA_LIST = [];
